<template>
	<div class="imgText">
		<div class="panoList">
		   <div class="wrapper" ref="wrapper">
		   		<ul class="fix" style="display:flow-root">
		   		    <li v-for="item in newsDate">
		   		        <a :href="item.panorama">
		   			        <span class="img"><img :src="item.cover_thumb" alt=""></span>
		   			        <span class="txt">{{item.caption}}</span>
		   		        </a>
		   		    </li>
		   		</ul>	
		   </div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import BScroll from 'better-scroll'
	export default {
		data(){
			return{
				p:0,
				newsDate:''
			}
		},
		created(){
			const that = this;
			this.$nextTick(() => {
			  	this.scroll = new BScroll(this.$refs.wrapper,{       
			  		//初始化better-scroll
			        probeType:1,   //1 滚动的时候会派发scroll事件，会截流。2滚动的时候实时派发scroll事件，不会截流。 3除了实时派发scroll事件，在swipe的情况下仍然能实时派发scroll事件
			        click: true,   //是否派发click事件
			        useTransition:false,  // 防止iphone微信滑动卡顿
			   	}) 
			   	//console.log(this.scroll)
			   	// 滑动过程中事件
			   	this.scroll.on('scroll',(pos)=>{
			   	    if(pos.y<(this.scroll.maxScrollY - 30)){
			   	        //console.log(pos.y)
			   	    }
			   	});  
			   	//滑动结束松开事件
			   	 this.scroll.on('touchEnd',(pos) =>{  //上拉刷新
			   	     if(pos.y<(this.scroll.maxScrollY - 30)){
			   	       
			   	     } 
			   	 })                                  
			})
		},
		mounted(){
			this.getNews()
		},
		methods:{
			getNews(){
				this.$http.get(this.$api+'/panorama_api.html')
				.then(res => {
					this.newsDate=res.data.data
				  	//console.log(this.newsDate,123)
				})
			},
		}
	}
</script>
<style scoped>
	a{color:#000}
	.wrapper{width: 100%;height:800px;overflow: hidden;position:relative;}
	.panoList{width:100%;padding-left: 1.05rem;margin-top:1rem;}
	.panoList li{width:4.75rem;float:left;margin-right: 1.2rem;height:7.4rem;}
	.panoList li:nth-child(3n){margin-right: 0;}
	.panoList a{display:block;}
	.panoList .img{display:-webkit-box;width:4.75rem;height:4.75rem;overflow: hidden;-webkit-box-orient:horizontal;-webkit-box-pack:center;-webkit-box-align:center;background-color: #eee;}
	.panoList .img img{width:100%}
	.panoList .txt{text-align: center;overflow: hidden;text-overflow: ellipsis;display:block;line-height: .9rem;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;padding-top:.45rem;}
</style>